import { breakpoints } from '@theme/breakpoints';
import styled from 'styled-components';

export default styled.section`
  padding: 4rem 2rem;
  position: relative;
  text-align: center;

  h2 {
    font-family: var(--font-geomanist);
    font-weight: 500;
    font-size: 48px;
    line-height: 55px;
    text-align: center;
    vertical-align: middle;

    @media (${breakpoints.mobilelgMax}) {
      font-size: 36px;
      line-height: 36px;
    }
  }

  @media (${breakpoints.tablet}) {
    padding: 4rem 2rem;
  }

  .postcodeInput {
    padding: 0;
    background: white;
    box-shadow: inset 0px 1px 6px #ada9fb83;
    border-radius: 8px;
    opacity: 1;
    font-size: 19px;
    height: 53px;
    text-align: left;
    width: 100%;
    border: solid 2px transparent;
    margin: 0 !important;

    input {
      background: transparent !important;
      height: 100%;
      width: 100%;
      padding: 0.7rem 0.875rem;
      font-family: inherit !important;
      font-size: inherit !important;
      min-width: unset !important;

      ::placeholder {
        color: black;
        font-family: var(--font-geomanist);
      }
      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: black;
        font-family: var(--font-geomanist);
      }
    }
  }
`;
